import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BuildingSurveyViewModel } from "src/app/shared/Models/buildingTableViewModel";
import { ChangeBlockForBuildingsDto } from "src/app/shared/Models/write/ChangeBlockForBuildingsDto";
import { AreaService } from "src/app/shared/services/area.service";
import { ToastService } from "src/app/shared/toast.service";
import { BuildingService } from "../../services/building.service";
import { Area } from "src/app/shared/Models/read";

@Component({
  selector: "app-change-block-modal",
  templateUrl: "./change-block-modal.component.html",
  styleUrls: ["./change-block-modal.component.scss"],
})
export class ChangeBlockModalComponent implements OnInit {
  @Input() buildings: BuildingSurveyViewModel[];
  cityList: string[] = [];
  fiberhoodList: Area[] = [];
  blockList: Area[] = [];
  selectedCity: string;
  selectedFiberhood: Area;
  selectedBlock: Area;

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly areaService: AreaService,
    private readonly toastService: ToastService,
    private readonly buildingService: BuildingService
  ) {}

  ngOnInit(): void {
    this.getCities();
  }

  getCities(): void {
    this.areaService.getCityNames().subscribe(
      (res) => {
        this.cityList = res;
      },
      () => this.showErrorWhilGettingAreaInfo()
    );
  }

  getFiberHoods(): void {
    this.areaService.getFiberHoodsForCityName(this.selectedCity).subscribe(
      (res) => {
        this.fiberhoodList = res;
      },
      (e) => this.showErrorWhilGettingAreaInfo()
    );
  }

  getBlocks(): void {
    this.areaService
      .getBlocksForFiberHoodId(this.selectedFiberhood.id)
      .subscribe(
        (res) => {
          this.blockList = res;
        },
        (e) => this.showErrorWhilGettingAreaInfo()
      );
  }

  selectCity(city: string) {
    if (city === this.selectedCity) return;
    this.selectedCity = city;
    this.selectedFiberhood = this.selectedBlock = null;
    this.getFiberHoods();
    this.blockList = [];
  }

  selectFiberhood(fiberhood: Area) {
    if (fiberhood.id === this.selectedFiberhood?.id) return;
    this.selectedFiberhood = fiberhood;
    this.selectedBlock = null;
    this.getBlocks();
  }

  selectBlock(block: Area) {
    if (block.id === this.selectedBlock?.id) return;
    this.selectedBlock = block;
  }

  updateBlock() {
    if (this.selectedBlock === null || this.buildings?.length === 0) return;

    this.buildingService
      .changeBlockForBuildings(
        new ChangeBlockForBuildingsDto({
          blockId: this.selectedBlock.id,
          buildingIds: this.buildings.map((b) => b.buildingId),
        })
      )
      .subscribe((res) => {
        this.activeModal.close("Success");
      });
  }

  private showErrorWhilGettingAreaInfo() {
    this.toastService.showErrorToast(
      $localize`:@@general.error:Something went wrong`,
      $localize`:@@validation.survey.geterror:Something went wrong while retrieving the data.`
    );
  }
}
